import React, { useState } from 'react';
import emailjs from 'emailjs-com';
import { useTranslation } from 'react-i18next';
import "./contact.css";

const Contact = () => {
  const { t } = useTranslation();
  const [copied, setCopied] = useState(false);
  const [formData, setFormData] = useState({
    from_name: '',
    reply_to: '',
    message: ''
  });
  const [isSubmitted, setIsSubmitted] = useState(false);

  const handleCopyEmail = () => {
    navigator.clipboard.writeText('bramplatier@gmail.com');
    setCopied(true);
    setTimeout(() => setCopied(false), 2500);
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    console.log('Sending form data:', formData);

    emailjs.sendForm('service_e0894ct', 'template_1p8n2zd', e.target)
      .then((result) => {
          console.log('EmailJS result:', result.text);
          setIsSubmitted(true);
          setTimeout(() => setIsSubmitted(false), 5000); // Verberg bericht na 5 seconden
      }, (error) => {
          console.error('EmailJS error:', error.text);
          alert('Failed to send the message, please try again.');
      });

    setFormData({
      from_name: '',
      reply_to: '',
      message: ''
    });
  };

  return (
    <section className="contact container section" id="contact">
      <h2 className="section__title">{t('contact_me')}</h2>
      <div className="contact__container grid">
        <div className="contact__info">
          <h3 className="contact__title">{t('contact_me')}</h3>
          <p className="contact__details">{t('contact_details')}</p>

          <div className="contact__quick-actions">
            <button className="contact__quick-btn" onClick={handleCopyEmail} title="Kopieer e-mailadres">
              <i className="icon-envelope"></i>
              {copied ? "E-mail Gekopieerd! ✓" : "Kopieer E-mailadres"}
            </button>
          </div>
        </div>

        <form className="contact__form" onSubmit={handleSubmit}>
          <div className="contact__form-group">
            <label className="contact__form-tag">{t('name')}</label>
            <input
              type="text"
              name="from_name"
              className="contact__form-input"
              placeholder={t('name')}
              value={formData.from_name}
              onChange={handleChange}
              required
            />
          </div>
          <div className="contact__form-group">
            <label className="contact__form-tag">{t('email')}</label>
            <input
              type="email"
              name="reply_to"
              className="contact__form-input"
              placeholder={t('email')}
              value={formData.reply_to}
              onChange={handleChange}
              required
            />
          </div>
          <div className="contact__form-group">
            <label className="contact__form-tag">{t('message')}</label>
            <textarea
              name="message"
              className="contact__form-input"
              placeholder={t('message')}
              value={formData.message}
              onChange={handleChange}
              required
            ></textarea>
          </div>
          <button type="submit" className="btn">{t('send_message')}</button>
          {isSubmitted && <p className="contact__confirmation">{t('message_sent')}</p>}
        </form>
      </div>
    </section>
  );
};

export default Contact;